import './App.css';
import ScrollToTop from './Components/scrolltotop/ScrollToTop';
import Company from './Pages/about/company/Company';
import Product from './Pages/about/product/Product';
import Airports from './Pages/applications/airports/Airports';
import ConstructionSites from './Pages/applications/construction-sites/ConstructionSites';
import GeneratorRoom from './Pages/applications/generator-rooms/GeneratorRoom';
import Hospitals from './Pages/applications/hospitals/Hospitals';
import Hotels from './Pages/applications/hotels/Hotels';
import OilGasProjects from './Pages/applications/oil-gas-pro/OilGasProjects';
import RoadRailPro from './Pages/applications/road-rail-pro/RoadRailPro';
import SportsEvents from './Pages/applications/sports-events/SportsEvents';
import TrafficAreas from './Pages/applications/traffic-areas/TrafficAreas';
import Contact from './Pages/contact/Contact';
import Home from './Pages/home/Home';
import { Routes, Route } from "react-router-dom";
import HomePage from './Pages/home/HomePage';
import Products from './Pages/products/Products';
import Application from './Pages/application/Application';
import Projects from './Pages/projects/Projects';
import Technology from './Pages/technology/Technology';
import Resources from './Pages/resources/Resources';
import AboutUs from './Pages/aboutus/AboutUs';

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Routes>
        <Route path="/test" element={<Home />} />
        <Route path="/company" element={<Company />} />
        <Route path="/product" element={<Product />} />
        <Route path="/airports" element={<Airports />} />
        <Route path="/construction-sites" element={<ConstructionSites />} />
        <Route path="/generator-room" element={<GeneratorRoom />} />
        <Route path="/hospitals" element={<Hospitals />} />
        <Route path="/hotels" element={<Hotels />} />
        <Route path="/oil-gas-pro" element={<OilGasProjects />} />
        <Route path="/road-rail-pro" element={<RoadRailPro />} />
        <Route path="/sports-events" element={<SportsEvents />} />
        <Route path="/traffic-areas" element={<TrafficAreas />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/products" element={<Products />} />
        <Route path="/application" element={<Application />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/tech" element={<Technology />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/abtus" element={<AboutUs />} />
      </Routes>
    </div>
  );
}

export default App;
